import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import CustomDialog from '../custom-material/dialog/Dialog'
import CustomDialogTitle from '../custom-material/dialog/DialogTitle'
import CustomButton from '../custom-material/button/Button'
import CustomTypography from '../custom-material/typography/Typography'

const styles = theme => ({
  dialog: {
    maxWidth: 400
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: 16
  },
  fieldRowContainer: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 12
  },
  fieldColumnContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    marginBottom: 12
  },
  fieldRowLabel: {
    marginRight: 8
  },
  fieldColumnLabel: {
    marginBottom: 8
  },
  input: {
    fontSize: '1em',
    border: '1px solid rgba(0, 0, 0, 0.42)',
    borderBottom: 0,
    borderRadius: 2,
    marginTop: '28px !important'
  },
  inputText: {
    paddingLeft: 3
  },
  inputShrinkLabel: {
    color: 'black',
    fontWeight: 600,
    fontSize: '1.42em'
  },
  actionContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 12
  }
})

const ConfirmProfileDialogComponent = ({ classes, dialogOpen, handleCloseDialog }) => (
  <CustomDialog classes={{paper: classes.dialog}} open={dialogOpen} onClose={handleCloseDialog} aria-labelledby='updates-dialog-title'>
    <CustomDialogTitle id='updates-dialog-title' disableTypography>
        It's time to confirm your profile<br />
        information!
    </CustomDialogTitle>
    <div className={classes.contentContainer}>
      <div>
        <CustomTypography align='center'>
          Please take a moment to make sure your<br />
          information is correct.
        </CustomTypography>
      </div>
      <div className={classes.actionContainer}>
        <img src='logo-web-white.png' alt='IPD Analytics' />
        <CustomButton key={'ok'} onClick={handleCloseDialog} className={classes.okButton} variant='contained' size='small' color='secondary' >{'Ok'}</CustomButton>
      </div>
    </div>
  </CustomDialog>
)

ConfirmProfileDialogComponent.propTypes = {
  classes: PropTypes.object.isRequired,
  dialogOpen: PropTypes.bool,
  handleCloseDialog: PropTypes.func
}

export default withStyles(styles)(ConfirmProfileDialogComponent)
